import './theme/site';

import { createRoot } from 'react-dom/client';
import { Route, Switch } from 'wouter';
import { SquishyBackgroundVariables } from './components/squishy-background-variables';
import { Leaderboard } from './leaderboard/leaderboard';
import { PersonalPage } from './leaderboard/personal-page';
import { Gallery } from './gallery/gallery';
import { Help } from './help/help';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const appElem = document.querySelector('#app');
const root = createRoot(appElem as HTMLElement);
const queryClient = new QueryClient();

// TODO: 404 page

root.render(
  <>
    <SquishyBackgroundVariables />
    <QueryClientProvider client={ queryClient }>
      <Switch>
        {/* @ts-ignore - component is a valid property for Route */}
        <Route path="/" component={ Leaderboard } />
        <Route path="/help" component={ Help } />
        <Route path="/gallery" component={ Gallery } />
        <Route path="/:username">
          { ({ username }: { username: string }) => {
            return (
              <Leaderboard>
                <PersonalPage username={ username } />
              </Leaderboard>
            );
          } }
        </Route>
      </Switch>
    </QueryClientProvider>
  </>
);
